<template>
  <Landing>
    <Login @ready-for-login="sendLoginRequest" @ready-to-get-code="getAuthCode" :user="user"></Login>
  </Landing>
</template>
<script>
import Landing from '@/page/byl/landing.vue'
import Login from '@/components/common/login/login.vue'
import { saveCookie, getCookie, removeCookie } from '@/store/cookies.js'
import { mapState, mapActions } from 'vuex'
export default {
  components: { Landing, Login },
  mounted () {
  },
  data () {
    return {
      user: null
    }
  },
  computed: {
    ...mapState('auth', ['isLogined'])
  },
  methods: {
    ...mapActions('auth', {
      localLogin: 'localLogin',
      codeLogin: 'codeLogin',
      getCode: 'getCode'
    }),
    sendLoginRequest (data) {
      var type = data[0]
      var user = data[1]
      if (user.checked === true) { // 判断复选框是否被勾选 勾选则调用配置cookie方法
        var p = {
          phone: user.accountName,
          password: user.password
        }
        saveCookie('rme_fresh', p) // 保存记住我状态
      } else {
        removeCookie('rme_fresh')
      }
      if (type === '1') { // 用户名密码登录
        this.localLogin(user)
      } else if (type === '2') { // 验证码登录
        this.codeLogin(user)
      }
    },
    getAuthCode (phone) {
      if (phone && phone !== (null || undefined || '')) {
        this.getCode(phone)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/byl/auth/login-page.vue